import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './core/auth/auth.interceptor';
import { SchedulesDaysEditorComponent } from './core/shared/components/schedules-days-editor/schedules-days-editor.component';
import { EmployeeRoleBadgeComponent } from './core/shared/components/employee-role-badge/employee-role-badge.component';
import { ToastContainerComponent } from "./core/shared/components/toast-container/toast-container.component";
import { ConfirmDialogComponent } from './core/shared/components/confirm-dialog/confirm-dialog.component';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SchedulesDaysEditorComponent,
    EmployeeRoleBadgeComponent,
    ToastContainerComponent,
    ConfirmDialogComponent
  ],
  exports: [
    SchedulesDaysEditorComponent
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
